// apps/website/src/config/swr.ts

import type { SWRConfiguration } from 'swr';

export const swrConfig: SWRConfiguration = {
  revalidateOnFocus: false,
  shouldRetryOnError: false,
  onError: (err, key) => {
    if ((window as any).__DG_DEBUG) {
      console.warn('[swr:error]', key, (err as any)?.message || err);
    }
  },
  onSuccess: (_data, key) => {
    if ((window as any).__DG_DEBUG) {
      console.log('[swr:ok]', key);
    }
  },
};
